const EVD_PREFIX = 'EVD-'

export function toEvidenceDisplayId(evidenceUuid: string): string {
  const compact = String(evidenceUuid || '')
    .replace(/-/g, '')
    .toUpperCase()
  if (compact.length < 6) return ''
  return `${EVD_PREFIX}${compact.slice(0, 6)}`
}

export function tokenizeEvidenceInput(raw: string): string[] {
  return String(raw || '')
    .split(/[\s,;\n]+/)
    .map((s) => s.trim())
    .filter(Boolean)
}
